import { render, staticRenderFns } from "./GolstatsLive.vue?vue&type=template&id=7f5bd8ec&scoped=true&"
import script from "./GolstatsLive.vue?vue&type=script&lang=js&"
export * from "./GolstatsLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5bd8ec",
  null
  
)

export default component.exports